import React from 'react'
import PropTypes from 'prop-types'
import styles from './Health.module.scss'
import { useIsMobileView } from '../../utils/isMobileView'

function Health({ t, status, healthCheck, ServerStatusIndicator, content }) {
  const isMobileView = useIsMobileView()

  const leftAlignStyle = {
    textAlign: 'left',
    fontFamily: "'JohnsonDisplay', Arial",
    marginLeft: '100px',
    marginTop: '45px',
    width: '85vw'
  }

  const leftAlignStyleMobile = {
    textAlign: 'left',
    fontFamily: "'JohnsonDisplay', Arial",
    marginLeft: '100px',
    marginTop: '45px',
  }

  return (
    <div style={isMobileView ? leftAlignStyleMobile : leftAlignStyle}>
      <h1 className={styles.headTitle}> { t('healthHeader') } </h1>
      <h1 className={styles.headName}>{t('health-api-header')}</h1>
      <hr className={styles.topLine} />
      <ServerStatusIndicator status={status} healthCheck={healthCheck} t={t} />
      {content}
    </div>
  )
}

Health.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  healthCheck: PropTypes.shape({
    status: PropTypes.bool,
    uptime: PropTypes.string,
  }).isRequired,
  ServerStatusIndicator: PropTypes.func.isRequired,
  content: PropTypes.node.isRequired,
}

export default Health
